<template>
  <div class="inventory-list">
    <div class="inventory-list-button" @click="show = !show">
      <i class="el-icon-s-order"></i>
      <span>择样清单</span>
    </div>
    <el-dialog
      title="择样清单"
      :visible.sync="show"
      :modal-append-to-body="false"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
    >
      <div class="inventory-list-body">
        <div class="body-button">
          <el-button size="small" type="primary">生成报价单</el-button>
          <el-button size="small" type="primary">导入报价单</el-button>
          <el-button size="small" type="danger">删除</el-button>
          <el-button size="small" type="primary">打印/导出</el-button>
        </div>
        <div class="body-table">
          <kTable :field="field"></kTable>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import kTable from "k-vue-table";
import field from "./field";
export default {
  components: {
    kTable
  },
  data() {
    return {
      show: false,
      field: field
    };
  }
};
</script>

<style lang="scss">
.inventory-list {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
}
</style>

<style lang="scss" scoped>
.inventory-list {
  .el-dialog__body {
    padding: 10px !important;
  }
  .inventory-list-button {
    position: relative;
    width: 100px;
    cursor: pointer;
    border-radius: 5px;
    line-height: 32px;
    background-color: #006afa;
    color: #fff;
    text-align: center;
    i {
      padding-right: 5px;
    }
  }
  .inventory-list-body {
    .body-table {
      padding: 10px 0;
      height: 400px;
    }
  }
}
</style>